export const getClickType = (e): 'left' | 'right' | 'Enter' | 'esc_key' => {
    if (e.key === 'Enter') return e.key;
    if (e.key === 'Escape') return 'esc_key';
    if (e.button === 0) {
      return 'left';
    } else {
      return 'right';
    }
};
